import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';

import { useBackgroundFreeze, useParentOnlyClickHandler } from '../../utils';

const modalRoot = document.querySelector('#global-modal-container');

const BigModal = ({
  children,
  onClose,
  className = '',
  overlayClassName = '',
  overlayCanClose = true,
}) => {
  const overlayReference = useRef();

  useParentOnlyClickHandler(onClose, overlayReference.current, overlayCanClose);
  useBackgroundFreeze();

  useEffect(() => {
    const keyListener = (event) => {
      if (event.keyCode === 27) {
        onClose(event);
      }
    };

    document.addEventListener('keydown', keyListener);

    return () => {
      document.removeEventListener('keydown', keyListener);
    };
  }, [onClose]);

  const overlayClass = classnames('big-modal-overlay', overlayClassName);

  if (modalRoot) {
    return ReactDOM.createPortal(
      <div
        ref={overlayReference}
        className={overlayClass}
        style={{ cursor: 'pointer' }}
      >
        <div className={`big-modal-wrapper ${className}`}>{children}</div>
      </div>,
      modalRoot
    );
  }
  return null;
};

export default BigModal;
